/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { Action, State } from '../redux';

const initialState: State['roomDetail'] = {
  room: null,
  participants: [],
  notes: [],
  notaryTasks: [],
  error: {
    hasError: false,
  },
  metadata: null,
};

export function roomReducer(state = initialState, action: Action) {
  switch (action.type) {
    case 'SET_ROOM_DETAIL':
      return { ...state, room: action.payload };
    case 'SET_PARTICIPANTS':
      return { ...state, participants: action.payload };
    case 'SET_ROOM_ERROR':
      return { ...state, error: action.payload };
    case 'SET_ROOM_METADATA':
      return { ...state, metadata: action.payload };
    case 'SET_ROOM_NOTES':
      return { ...state, notes: action.payload };
    case 'SET_ROOM_NOTARY_TASKS':
      return { ...state, notaryTasks: action.payload };
    default:
      return state;
  }
}
